/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var citySelector = document.querySelector('.submit-city-name');
citySelector.addEventListener("click", function(){
  var selectedCity = document.querySelector('.city-popup-content .select-city-wrap select.city-name').value;;
  if(selectedCity != ''){
  //localStorage.setItem('selectedCity', selectedCity);
    setCookie("selectedCity",selectedCity,15);
  }
if (selectedCity === 'delhi-ncr') {
   
    }
  $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() { 
        window.location.reload()
      },
      error: function(XMLHttpRequest, textStatus) {
        window.location.reload()
      }
    });
  
  console.log('changed city');
});


// checkURL
const browserurl = window.location.href;
const pathname = new URL(browserurl).pathname;
const lastSegment = pathname.split('/').pop();

console.log('lastSegment', lastSegment); // This will log the last segment, like "bangalore"
if(lastSegment == 'bengaluru'){
   setCookie("selectedCity",'bengaluru');
// if (!sessionStorage.getItem('pageReloaded')) {
//   sessionStorage.setItem('pageReloaded', 'true');
//   window.location.reload();
// }
  window.location="/"
}

const cityName = getCookie("selectedCity");
console.log('cityName ' + cityName);
if (cityName == null || cityName == '') {
  document.querySelector('.city-popup-main').style.display = 'block';
} else {
  if (cityName == 'delhi-ncr') {
    document.querySelector('.cityname-qrrow-wrpa span.cityname').innerHTML = 'delhi-NCR';
    const selectDivs = document.querySelectorAll(".collectionAll, .muffinsDelhi, .bagelsDelhi, .chrisDelhi, .nibblesDelhi, .cookiesDelhi, .lavaashDelhi, .dessertsDelhi");
    selectDivs.forEach(function (selectDiv) {
      selectDiv.style.display = "block";
    });
  }
  else if (cityName == 'mumbai-pune') {
    document.querySelector('.cityname-qrrow-wrpa span.cityname').innerHTML = 'mumbai-pune';
    const selectDivs = document.querySelectorAll(".collectionAll, .muffinsMumbai, .bagelsMumbai, .chrisMumbai, .nibblesMumbai, .cookiesMumbai, .lavaashMumbai, .dessertsMumbai");
    selectDivs.forEach(function (selectDiv) {
      selectDiv.style.display = "block";
    });
  }
  else if (cityName == 'kolkata') {
    document.querySelector('.cityname-qrrow-wrpa span.cityname').innerHTML = 'kolkata';
    const selectDivs = document.querySelectorAll(".collectionAll, .muffinsKolkata, .bagelsKolkata, .chrisKolkata, .nibblesKolkata, .cookiesKolkata, .lavaashKolkata, .dessertsKolkata");
    selectDivs.forEach(function (selectDiv) {
      selectDiv.style.display = "block";
    });
  }
    else if (cityName == 'bengaluru') {
    document.querySelector('.cityname-qrrow-wrpa span.cityname').innerHTML = 'bengaluru';
    const selectDivs = document.querySelectorAll(".collectionAll, .muffinsDelhi, .bagelsDelhi, .chrisBengaluru, .nibblesDelhi, .cookiesDelhi, .lavaashDelhi, .dessertsBangalore");
    selectDivs.forEach(function (selectDiv) {
      selectDiv.style.display = "block";
    });
  }else {
    document.querySelector('.cityname-qrrow-wrpa span.cityname').innerHTML = cityName;
  }
  
}



const ProductGridItem = document.querySelectorAll('.ProductList .Grid__Cell');
ProductGridItem.forEach(gridcell =>{
    gridcell.style.display = 'none'
    if(gridcell.classList.contains(cityName)){
        gridcell.style.display = 'inline-block'
    }
});

  setTimeout(function(){
    const ProductCarouselItem = document.querySelectorAll('.ProductList--carousel .Carousel__Cell');
    console.log('ProductCarouselItem ',ProductCarouselItem.length);
    let left = 0;
    ProductCarouselItem.forEach(gridcell =>{
      gridcell.style.display = 'none'
      if(gridcell.classList.contains(cityName)){
        gridcell.style.display = 'inline-block';
        gridcell.style.left = left+'%';
        left += 25;
      }
    });
  },2000);

const currectPageUrl = window.location.href; 
if(currectPageUrl.includes('/cart')){
  console.log('cart page', cityName);
  setTimeout(function(){
    document.querySelector('footer.Cart__Footer input.city-selected').value = cityName;
  },4000);
}

setTimeout(function(){
  document.querySelector('#sidebar-cart input.city-selected').value = cityName;
},4000);




document.querySelector('.city-popup-content .close-city-popyp').addEventListener('click', function(){
  window.location.reload();
});

document.querySelector('a.change-city-icon').addEventListener('click', function(){
  document.querySelector('.city-popup-content .select-city-wrap select.city-name').value = cityName;
  document.querySelector('.city-popup-main').style.display = 'block';
});

function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}




